import type { ComponentProps } from 'react';
import { Cell as AriaCell } from 'react-aria-components';
import cx from 'clsx';

import { useTableVariant } from './Table';

import styles from './Cell.module.css';

type Props = { isNumbered?: boolean } & ComponentProps<typeof AriaCell>;

export const Cell = ({ children, isNumbered, ...props }: Props) => {
  const variant = useTableVariant();

  return (
    <AriaCell
      {...props}
      className={cx(props.className, styles.Cell, {
        [styles.IsNumbered]: isNumbered,
        [styles.slim]: variant === 'slim',
      })}
    >
      {children}
    </AriaCell>
  );
};
